import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';

import css from './ListingPage.module.css';

const SectionInstantBookingMaybe = props => {
  const { listing } = props;

  if (!listing?.attributes?.publicData) {
    return null;
  }

  const { publicData } = listing.attributes;
  const instantBookingEnabled = publicData.instantBookingEnabled;

  if (!instantBookingEnabled) {
    return null;
  }

  return (
    <div className={css.sectionInstantBooking}>
      <div className={css.instantBookingBadge}>
        <FormattedMessage id="ListingCard.instantBooking" />
      </div>
      <p className={css.instantBookingInfo}>
        <FormattedMessage id="ListingPage.instantBookingInfo" />
      </p>
    </div>
  );
};

export default SectionInstantBookingMaybe;
